import { Clock } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ProductImageGallery from '../../ui/ProductImageGallery'
import { formatNumber } from '../../../utils/formatNumber'
import PriceText from '../../ui/PriceText'

type Props ={
    id:number,
    name:string,
    productNum:number,
    images:string[],
    catgeory:string,
    prepTime:number,
    shortDescrption:string,
    longDescription:string
    price:number
}

function ProductCard({id,name,productNum,images,catgeory,prepTime,shortDescrption,longDescription,price}:Props) {
  const {t} = useTranslation();
  return (
    <div className="flex items-start gap-12 p-6 md:flex-row flex-col">
      <ProductImageGallery images={images}/>

      {/* Second div: Details */}
      <div className="flex-1 flex flex-col gap-3">
        {/* Product name and ID */}
        <div className=' flex justify-between'>
          <h2 className="text-xl font-black text-Black  capitalize">{name}</h2>
          <p className="text-[14px] text-DarkGrey3 font-semibold"># {formatNumber(productNum)}</p>
        </div>

        {/* Category, Duration, Price */}
        <div className="flex items-center gap-6 justify-between">
          <p className="font-normal text-Black text-[12px] capitalize">{catgeory}</p>
         <div className=' flex gap-6'>
             <p className="flex items-center gap-1 text-Black text-[12px]">
            <Clock size={16} /> {formatNumber(prepTime)} {t('mins')}
          </p>
          <div className='flex items-center gap-1'>
            <img src={`/Vector.png`} alt=""  className='w-[13.33px] h-[14.93px]'/>
            <p className=" text-primaryButton font-black"><PriceText color='primaryButton' value={price}/></p>
          </div>
         </div>
        </div>

        {/* Short Description */}
        <p className="text-Black font-bold text-[12px]">{shortDescrption}</p>

        {/* Long Description */}
        <p className="text-gray-600 text-[12px]">
          {longDescription}
        </p>
      </div>
    </div>
  )
}

export default ProductCard

